module.exports = __webpack_public_path__ + "img/shang.08561ec1.svg";